<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="分类名称" prop="typeName" >
        <a-input v-model="form.typeName" placeholder="请输入挑战赛分类" />
      </a-form-model-item>
      <a-form-model-item label="分类logo" prop="typeLogo" >
        <file-upload type="image" :defaultList="form.typeLogoArr" :count="1" :imgSize="'310*200'"
                     @input="getImg($event, 'typeLogo')"></file-upload>
      </a-form-model-item>

<!--      <a-form-model-item label="挑战赛规则" prop="challengeRule" >-->
<!--        <a-input type="textarea" v-model="form.challengeRule"/>-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="挑战赛规则" prop="challengeRule" >
        <editor type="textarea" v-model="form.challengeRule"/>
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getType, addType, updateType } from '@/api/challenge/type'
import {guid} from "@/utils/ruoyi";
import Editor  from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        typeName: null,

        typeLogo: null,
        typeLogoCount: 0,
        typeLogoArr: [],

        challengeRule:null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        typeName: [
          { required: true, message: '分类名称不能为空', trigger: 'blur' }
        ],
        typeLogo: [
          { required: true, message: '分类logo不能为空', trigger: 'blur' }
        ],
        // challengeRule:[
        //   { required: true, message: '挑战赛规则不能为空', trigger: 'blur' }
        // ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },

    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        typeName: null,
        typeLogo: null,
        typeLogoCount: 0,
        typeLogoArr: [],
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.open = true
      this.formType = 2
      const id = row ? row.id : ids
      getType({"id":id}).then(response => {
        this.form = response.data

        this.formTitle = '修改'
        let that = this;
        this.form.typeLogoArr = []
        this.form.typeLogoArr.push({
          uid: guid(8, 10),
          name: that.form.typeLogo,
          status: 'done',
          halfUrl: that.form.typeLogo,
          url: that.form.typeLogo,
          path: that.form.typeLogo
        })
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateType(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addType(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
